import { commonTranslations } from '../constants';

export const administrationEditTranslations = {
  ...commonTranslations,
  switch_to_scroll: 7977,
  switch_to_tab: 7978,
  user_administration_label: 5241,
  role_administration_label: 8038,
  id: 631,
  name: 5244,
  do_you_want_to_provide: 7610,
  remove_all_role_based: 7611,
  remove_all_section: 8435,
  authorisation: 7612,
  unit_location_usergroup: 7613,
  user_type_and_group: 7614,
  language: 5248,
  location: 7616,
  unit: 5262,
  current_user_group: 5249,
  main_user_group: 5250,
  user_type: 7620,
  disabled_date: 5251,
  password: 4855,
  email: 5245,
  latest_login: 5252,
  created: 5253,
  modified: 5254,
  by: 8789,
  information_not_available: 8791,
  required_fields: 7745,
  search: 7345,
  validation_required: 7633,
  added_user: 7629,
  not_added_user: 7631,
  updated_user: 7630,
  not_updated_user: 7632,
  duplicated_user: 8243,
  save: 5564,
  dont_save: 7628,
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,
  no_options_found: 7644,
  select_one_option: 7344,
  operation: 4001,
  application_or_case: 7699,
  choose_application_or_case: 7700,
  extended_access: 7701,
  validation_error: 7702,
  done: 7338,
  add: 5783,
  create: 8148,
  remove: 5913,
  case_type: 3514,
  responsible_for_unit: 7721,
  responsible_for_unassigned_cases_and_actions: 8841,
  subscriber_groups: 8842,
  subscriber_groups_card_title: 8853,
  subscriber_groups_expander_title: 8929,
  restricted_access: 7985,
  access_to_screen: 7986,
  screen: 7987,
  must_be_equal: 7681,
  must_be_unique: 8105,
  change: 7974,
  confirm_password: 7973,
  change_password: 7971,
  reset_password: 7972,
  change_id_disclaimer: 8153,
  set: 7975,
  new_role: 5482,
  add_user: 7657,
  new_user: 5541,
  edit_user: 8069,
  duplicate_user: 8240,
  fields: 8000,
  user_and_person_fields: 8001,
  user_groups: 8002,
  user_group: 8003,
  user_occurrence_in_preson_field_lists: 8004,
  access_to_administrate_user_group: 8005,
  update_user: 8006,
  no_access_has_been_granted: 8007,
  no_additional_info_has_been_added: 8100,
  no_role_assigned: 8817,
  no_fields_available: 8399,
  default_values: 8021,
  default_value: 8020,
  code_table: 8019,
  field: 8018,
  access_base_on_role: 8022,
  not_selected: 3747,
  edit_details_title: 8044,
  default_value_already_set: 8031,
  default_value_add_new: 8126,
  default_value_add_new_fields: 8127,
  default_value_add_another: 8125,
  edit_role_title: 8036,
  edit_role_details_role_id: 8041,
  edit_role_details_role_name: 8042,
  edit_role_details_code: 8043,
  edit_role_add_role: 8045,
  edit_role_update_role: 8046,
  edit_role_save_role: 8047,
  edit_role_duplicate_save_role: 8424,
  edit_role_duplicate_role: 8424,
  additional_information: 5467,
  choose_extra_fields: 8060,
  extra_fields: 8061,
  extra_field: 8062,
  must_be_withing_range: 7939,
  role_updated: 8048,
  user_load_failed_msg: 8053,
  role_load_failed_msg: 8054,
  new_role_msg: 8055,
  duplicate_role: 8423,
  role_successfully_deleted: 8050,
  no_roles_has_been_added: 8072,
  remove_all_role_based_access: 8144,
  no_access_to_role_administration: 8296,
  no_access_to_user_administration: 8297,

  change_user_id: 5485,
  old_user_id: 5591,
  new_user_id: 5590,
  user_id_changed: 8077,
  latest_activity: 8585,
  latest_activity_info_text: 8586,
  latest_activity_no_activity: 8599,

  save_user_load_overlay_text: 8122,
  save_role_load_overlay_text: 8123,

  access_card_settings_to_selected_roles: 8084,
  access_selection_panel_switch_custom_message_first: 8085,
  access_selection_panel_switch_custom_message_second: 8086,

  access_selection_panel_switch_role_based_message_first: 8087,
  access_selection_panel_switch_role_based_message_second: 8088,

  role_base_access_custom_button_tab: 8089,
  role_base_access_role_button_tab: 8090,

  access_selection_panel_switch_custom_button: 8091,
  access_selection_panel_switch_role_based_button: 8092,

  alternative_id: 4898,
  no_alternative_id_has_been_added: 8113,

  database_user_delete_button: 8093,
  database_user_reset_button: 8094,
  database_user_create_button: 8095,

  database_user_delete_modal_title: 8097,
  database_user_delete_modal_desc: 8096,

  database_user_reset_modal_title: 8098,
  database_user_create_modal_title: 8099,

  database_user_create_message: 8103,
  database_user_reset_message: 8102,
  database_user_delete_message: 8101,

  database_create_user_info: 8104,
  database_can_not_change_user_id_info: 8112,

  access_to_assign_roles_title: 8114,
  access_to_assign_roles_field: 5339,
  access_to_assign_roles_group: 8042,

  password_policy_user_account: 8118,
  password_policy_db_account: 8119,

  add_default_value_button_text: 8128,
  add_default_value_disclaimer: 8145,
  add_default_value_duplicated_values: 8440,
  add_user_group_button_text: 8129,
  add_case_type_button_text: 8130,
  add_application_or_case_type_button_text: 8131,
  add_user_and_person_fields_button_text: 8132,
  add_roles_button_text: 8133,
  add_units_button_text: 8136,
  add_units_group_text: 8456,
  add_subscriber_groups: 8843,

  duplicate_user_title: 8241,
  duplicate_user_save_text: 8242,

  search_required_message: 8146,
  operation_required_message: 8402,

  select_all: 8420,
  clear_all: 8421,

  page_of: 8454,
  manage_options: 8521,

  technical_user: 8790,
  technical_user_update: 8764,
  technical_user_update_description: 8765,

  technical_user_delete: 8767,
  technical_user_delete_description: 8768,
  technical_user_delete_confirmation: 8769,

  veracity_redirect_info: 8644,

  // default role
  mark_as_default_role_success: 8655,
  mark_as_default_role_failure: 8656,
  remove_default_role_success: 8658,
  remove_default_role_failure: 8657,
  set_as_default_role: 8659,
  remove_default_role: 8660,
  use_as_default_role: 8661,
  default_role_tooltip: 8662
};

export type AdministrationEditTranslation = {
  readonly [T in keyof typeof administrationEditTranslations]: string
};

export const PublicUserType = 4;
